import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import DataDashboard from './components/DataDashboard';
import SupplySummary from './components/SupplySummary';
import DemandSummary from './components/DemandSummary';
import MarketTrends from './components/MarketTrends';
import RankingBoard from './components/RankingBoard';
import { useState, useEffect } from 'react';
import { homeApi, type HomeApiResponse } from '@/services/api';
import { ScrollReveal } from '@/components/base/Animations';

export default function Home() {
  const [data, setData] = useState<HomeApiResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = () => {
    setLoading(true);
    setError(null);
    homeApi
      .get()
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : '数据加载失败');
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto rounded-full border-2 border-primary-500 border-t-transparent animate-spin"></div>
          <p className="text-foreground-500 text-sm mt-4">正在加载数据...</p>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto rounded-full bg-background-100 flex items-center justify-center">
            <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
          </div>
          <p className="text-foreground-600 text-sm mt-4">{error || '加载失败'}</p>
          <button
            onClick={fetchData}
            className="mt-4 px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer"
          >
            重新加载
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ScrollReveal><DataDashboard stats={data.stats} /></ScrollReveal>
        <ScrollReveal><SupplySummary items={data.latestSupply} /></ScrollReveal>
        <ScrollReveal><DemandSummary items={data.latestDemand} /></ScrollReveal>
        <ScrollReveal><RankingBoard /></ScrollReveal>
        <ScrollReveal><MarketTrends marketData={data.marketData} /></ScrollReveal>
      </main>
      <Footer />
    </>
  );
}